import { ModalDialog } from '../ModalDialog/ModalDialog'
import { Button } from '../Button/Button'
import Styles from './ConfirmationDialog.module.scss'

interface Props {
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmationDialog = ({ onConfirm, onCancel }: Props) => (
  <ModalDialog
    title="Are You Sure?"
    onClose={onCancel}
    footer={
      <>
        <Button size="md" variant="tertiary" onPress={onCancel}>
          No
        </Button>
        <Button className={Styles.confirmButton} size="md" onPress={onConfirm}>
          Yes
        </Button>
      </>
    }
  >
    Are you sure you want to cancel changes?
  </ModalDialog>
)
